<template>
  <DelDialog
    width="1000px"
    :dialogVisible="configVisible"
    @handleClose="handleCancel"
    @handleConfirm="handleConfirm"
  >
    <template #title>{{$t('newProjectV2.configPunctuateRule')}}</template>
    <el-form
        ref="form"
        label-position="left"
        :model="form"
      >
        <el-row>
          <el-col :span="11" class="left">
            <el-form-item :label="$t('newProjectV2.sentenceEnd')" prop="language" style="width: 100%">
              <el-input v-model="form.sentEnding" maxlength="200"></el-input>
            </el-form-item>
            <el-form-item :label="$t('newProjectV2.abbr')" prop="format">
              <el-input type="textarea" v-model="form.sentAbbr" maxlength="200" />
            </el-form-item>
            <el-form-item :label="$t('newProjectV2.numAbbr')" prop="format" class="left-last">
              <el-input type="textarea" v-model="form.numberAbbr" maxlength="200" />
            </el-form-item>
          </el-col>
          <el-col :span="2">&nbsp;</el-col>
          <el-col :span="11" class="right">
            <el-form-item :label="$t('newProjectV2.originalText')" class="original-text" prop="format">
              <el-input type="textarea" v-model="form.remark" maxlength="500" show-word-limit/>
            </el-form-item>
            <el-form-item :label="$t('newProjectV2.punctuatePreview')" prop="format">
              <ul class="target-top">
                <li>
                  <el-button size="mini" @click="test">{{$t('newProjectV2.previewPunctuateEffect')}}</el-button>
                </li>
              </ul>
              <el-input type="textarea" v-model="form.desc" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
  </DelDialog>
</template>

<script>
import DelDialog from '@/components/delDialog';

import { updateRule, testRule } from "@/services/dialogApi";

export default {
  name: "configPunctuateRules",
  props: ["configVisible", "editRule"],
  data() {
    return {
      form: {
        id: "",
        remark: "",
        numberAbbr: "",
        sentAbbr: "",
        sentEnding: "",
        desc: "",
      },
    };
  },
  components: {
    DelDialog
  },
  methods: {
    //数组排序
    handleSort: function () {
      const self = this;
      let str = self.form.numberAbbr;
      let reg = /^[0-9][A-Za-z0-9\\,]*$/g;
      let bool = reg.test(str);
      if (bool) {
        let strArr = str.split(",");
        strArr.sort(function (a, b) {
          return parseInt(a) - parseInt(b);
        });
        Reflect.set(self.form, "numberAbbr", strArr.toString());
      } else {
        self.$message.closeAll();
        self.$message({
          message: self.$t('newProjectV2.numAbbrOnly'),
          type: "warning",
        });
        return true;
      }
    },
    handleConfirm() {
      let self = this;

      if (self.form.sentEnding.trim() === "") {
        self.$message.closeAll();
        self.$message({
          message: self.$t('newProjectV2.sentenceEndNotEmpty'),
          type: "warning",
        });
        return;
      }

      //缩写验证
      let reg = /^[a-zA-Z0-9,，.\u4e00-\u9fa5]+$/;
      let str = self.form.sentAbbr;
      if(str){
        let bool = reg.test(str);
        if (!bool) {
          self.$message.closeAll();
          self.$message({
            message: self.$t('newProjectV2.abbrOnly'),
            type: "warning",
          });
          return;
        }
      }

      //数字缩写验证
      if (!!(self.form.numberAbbr)) {
        let sort = (self.handleSort());
        if (sort) {
          return;
        }
      }
      //  else {
      //   self.$message.closeAll();
      //   self.$message({
      //     message: self.$t('newProjectV2.numAbbrNotEmpty'),
      //     type: 'warning'
      //   });
      //   return;
      // }

      updateRule(self.form).then(resp => {
        if (resp.success) {
          self.$message.closeAll();
          self.$message({
            message: self.$t('newProjectV2.configSuccess'),
            type: "success"
          });
          self.$emit('updateRule');
          self.handleCancel();
        }
      });
    },
    handleCancel() {
      this.form.desc = '';
      this.$emit("handleCancelConfig");
    },
    async test () {
      this.form.desc = '';
      let param = {
        content: this.form.remark,
        numberAbbr: this.form.numberAbbr,
        sentAbbr: this.form.sentAbbr,
        sentEnding: this.form.sentEnding
      };
      let { result } = await testRule(param);
      result.forEach((item) => {
        this.form.desc += item + '\n';
      });
    }
  },
  watch: {
    editRule: {
      handler(newVal) {
        this.form.id = newVal.id;
        this.form.remark = newVal.remark;
        this.form.numberAbbr = newVal.numberAbbr;
        this.form.sentAbbr = newVal.sentAbbr;
        this.form.sentEnding = newVal.sentEnding;
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
@import "./assets/style.less";
/deep/.el-input__count{
  background: transparent;
}
</style>
